import {
  ItProjectsClient,
  ItProjectStatus,
  ItProjectStatusCountDto,
  PageLayoutWidgetDto,
} from "@lib/ShiOneClient";
import { useApi } from "../../utils";
import { Box, Button, Container } from "@mui/material";
import { AppendIfPrefixExists } from "../../../../modules/sitePaths";
import SummaryWidget from "shared-ui/src/widgets/standard/SummaryWidget";
import { graphColors, NoContent, Summary, useSummaryData } from "shared-ui";
import shiColors from "shared-ui/src/theme/shiColors";
import { itProjectsStatusCountsQueryKey } from "@features/it-projects-feature/hooks/useItProjects";

const itProjectStatusColorPriorities: Record<string, string> = {
  [ItProjectStatus.Planning]: shiColors.blue.DEFAULT,
  [ItProjectStatus.InProgress]: shiColors.orange.DEFAULT,
  [ItProjectStatus.OnHold]: shiColors.gray.light,
  [ItProjectStatus.Canceled]: shiColors.red.DEFAULT,
  [ItProjectStatus.Closed]: shiColors.green.medium,
};

const placeholderData: ItProjectStatusCountDto[] = [
  { status: ItProjectStatus.Planning, count: 3 } as ItProjectStatusCountDto,
  { status: ItProjectStatus.InProgress, count: 5 } as ItProjectStatusCountDto,
  { status: ItProjectStatus.OnHold, count: 2 } as ItProjectStatusCountDto,
];

export default function ItProjectsWidget({
  pageLayoutWidget,
}: {
  pageLayoutWidget: PageLayoutWidgetDto;
}) {
  const response = useItProjectsWidgetData();

  return (
    <SummaryWidget
      pageLayoutWidget={pageLayoutWidget}
      useQueryFunction={() => response}
      leftLabel={"Projects"}
      cardActions={
        response.data && response.data.length > 0 ? <CardActions /> : <></>
      }
      noDataElement={
        <NoContent
          header="No Projects"
          body="Projects will appear here once they have been created"
          actionText={""}
        />
      }
    />
  );
}

function useItProjectsWidgetData() {
  const api = useApi(ItProjectsClient);

  return useSummaryData<ItProjectStatusCountDto[]>({
    queryKey: [...itProjectsStatusCountsQueryKey],
    apiFunction: () => api.getStatusCounts().then((r) => r || []),
    transformFunction: (data) => transformStatusCountsIntoSummaryData(data),
    placeholderData,
  });
}

function transformStatusCountsIntoSummaryData(
  statusCounts: ItProjectStatusCountDto[] | undefined
): Summary[] {
  if (!statusCounts) {
    return [];
  }

  return statusCounts.map((item, index) => ({
    name: "",
    label: item.status?.replace(/([A-Z])/g, " $1") as string,
    data: item.count as number,
    color:
      item.status && item.status in itProjectStatusColorPriorities
        ? itProjectStatusColorPriorities[item.status]
        : graphColors[index],
  }));
}

function CardActions() {
  return (
    <Container disableGutters={true}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button href={AppendIfPrefixExists("/projects")}>
          View Projects
        </Button>
      </Box>
    </Container>
  );
}
